<template>
  <v-app id="App" dark>
    <transition name="_fade">
      <v-app-bar
        v-if="section && this.$vuetify.breakpoint.mdAndUp"
        app
        color="transparent"
        dark
      >
        <v-row>
          <!-- <div style="color:white" v-text="this.windowTop"></div> -->

          <v-spacer />
          <v-btn
            text
            style="height: 60px;"
            @click="$vuetify.goTo('#intro', options(800, 'easeInQuad', 0))"
            >Intro</v-btn
          >
          <v-btn
            text
            style="height: 60px;"
            @click="$vuetify.goTo('#about', options(800, 'easeInQuad', 65))"
            >About</v-btn
          >
          <v-btn
            text
            style="height: 60px;"
            @click="$vuetify.goTo('#projects', options(800, 'easeInQuad', 0))"
            >Projects</v-btn
          >
          <v-btn
            text
            style="height: 60px;"
            @click="$vuetify.goTo('#skills', options(800, 'easeInQuad', 0))"
            >Skills</v-btn
          >
          <v-btn
            text
            style="height: 60px;"
            @click="$vuetify.goTo('#contact', options(800, 'easeInQuad', 0))"
            >Contact</v-btn
          >
        </v-row>
      </v-app-bar>
    </transition>
    <v-main>
      <HelloWorld v-if="false" />
      <Intro />
      <About />
      <Projects />
      <Skills />
      <Contact />
    </v-main>
    <v-footer
      id="footer"
      absolute
      dark
      fixed
      style="background-color: #252734;"
      class="py-4"
      ><v-btn
        icon
        x-large
        color="white"
        href="https://www.linkedin.com/in/saikiran-reddy/"
        target="_blank"
        ><v-icon>mdi-linkedin</v-icon></v-btn
      >

      <v-btn
        icon
        x-large
        color="white"
        href="https://github.com/kingavatar"
        target="_blank"
        ><v-icon>mdi-github</v-icon></v-btn
      >
      <v-btn icon x-large color="white" href="mailto:saikiran.reddy@iiitb.org"
        ><v-icon>mdi-email</v-icon></v-btn
      >
      <v-spacer></v-spacer>
      <div>
        Copyright &copy; 2020 Saikiran
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import HelloWorld from "./components/HelloWorld";
import Intro from "./components/Intro";
import About from "./components/About";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Contact from "./components/Contact";

export default {
  name: "App",

  components: {
    HelloWorld,
    Intro,
    Projects,
    About,
    Skills,
    Contact
  },

  data: () => ({
    section: false,
    windowTop: window.top.scrollY
  }),
  methods: {
    handle() {
      this.windowTop = window.top.scrollY;
      this.section = this.windowTop > 255;
    },
    options(du, eas, off) {
      return { duration: du, easing: eas, offset: off };
    }
  },
  created: function() {
    document.title = "Saikiran Reddy";
  },
  mounted: function() {
    window.addEventListener("scroll", this.handle);
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handle);
  }
};
</script>

<style scoped>
#App {
  height: 100%;
  background-color: #333646;
  overscroll-behavior: none;
}
html {
  background-color: #333646;
}
._fade-enter-active {
  transition: opacity 0.5s;
}
._fade-leave-active {
  transition: opacity 1s;
}

._fade-enter, ._fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";
@media #{map-get(
    $display-breakpoints,
    "sm-and-down"
  )} {
  body {
    overflow-x: hidden;
  }
}
</style>
